
const RoleNames = ["Benutzer", "Verwalter", "Admin", "Superadmin","Kunde","Entwickler"];

export const getRoleName = (index) => {
  if (index < RoleNames.length) return RoleNames[index];
};

export const getRoleNames = (roleNrArr) => {
  return roleNrArr.map((nr, index) => {
    return getRoleName(nr);
  });
};
export const ROLE_NAME = {
  BENUTZER: 0,
  VERWALTER: 1,
  ADMIN: 2, 
  SUPERADMIN: 3,
  KUNE: 4, 
  ENTWICKLER: 5,
};
